module.exports = __webpack_public_path__ + "static/media/login3.eb266a08.jpg";